import { css } from "styled-components";

import {
  ACCENT_PRIMARY,
  ERROR_LIGHT,
  ERROR_LIGHTEST,
  GRAY,
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  WHITE
} from "../colors";
import componentSizes from "../constants/componentSizes";
import { LARGE_SCREEN } from "../constants/screenSizes";

const inputSizeStyles = {
  [componentSizes.SM]: css`
    height: 32px;
  `,
  [componentSizes.MD]: css`
    height: 40px;
  `,
  [componentSizes.LG]: css`
    height: 48px;
  `
};

export const withInputSizeStyles = ({ size }) => inputSizeStyles[size];

export const textFieldStyles = css`
  -webkit-font-smoothing: antialiased;
  background-color: ${WHITE};
  border: 1px solid ${GRAY};
  color: ${TEXT_PRIMARY};
  font-family: "Source Sans Pro", Helvetica, Arial, Geneva, sans-serif;
  font-size: 14px;
  line-height: 22px;
  padding: 8px 15px;
  text-transform: none;
  width: 100%;

  &[aria-invalid="true"] {
    border-color: ${ERROR_LIGHT};
    background-color: ${ERROR_LIGHTEST};
  }

  &::placeholder {
    color: ${TEXT_SECONDARY};
  }

  &:focus {
    border-color: ${ACCENT_PRIMARY};
  }

  &:disabled {
    background-color: ${GRAY_LIGHT};

    &:not([value=""]) {
      background-color: ${GRAY_LIGHTEST};
    }
  }

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    font-size: 16px;
    line-height: 24px;
  }
`;
